import { useCallback, useMemo, useState } from "react";
import { useLazySaveUiExceptionQuery } from "../features/Feature_GeneralAppElements/GeneralAppElements_Api";

interface ErrorMessage {
  stk?: string;
  msg?: string;
}

interface SaveUIExceptionProps {
  moduleName?: string;
  pageName?: string;
  statusCode: number;
  errorMessage?: ErrorMessage;
  uiDisplayMessage?: string;
}

export const useSaveUIException = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [response, setResponse] = useState<any>(null);
  const [saveUIExceptionApi] = useLazySaveUiExceptionQuery();

  const triggerSaveUIException = useCallback(
    async (props: SaveUIExceptionProps) => {
      const {
        moduleName,
        pageName,
        statusCode,
        uiDisplayMessage,
        errorMessage,
      } = props;

      // Construct payload directly without useMemo inside useCallback
      const payload = {
        module: moduleName || "",
        pageName: pageName || "",
        type: "UI",
        httpStatusCode: statusCode,
        httpErrorCode: "error",
        httpErrorMessage: "errorMessage",
        uiDisplayTitle: "Technical Error",
        uiDisplayMessage: uiDisplayMessage || "",
        errorStack: errorMessage?.stk || "",
        errorStackMessage: errorMessage?.msg || "",
      };

      setLoading(true);
      setError(null);
      try {
        const res = await saveUIExceptionApi(payload);
        setResponse(res);
        return res;
      } catch (err: any) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    },
    [saveUIExceptionApi],
  );

  return {
    triggerSaveUIException,
    loading,
    error,
    response,
  };
};
